import { async } from 'regenerator-runtime';
import * as model from './model.js';
import recipeView from './views/recipeView.js';
import searchView from './views/searchView.js';
import resultsView from './views/resultsView.js';
import paginationView from './views/paginationView.js';
import bookmarksView from './views/bookmarksView.js';
import addRecipeView from './views/addRecipeView.js';
import shoppingListView from './views/shoppingListView.js';
import sortResultsView from './views/sortResultsView.js';
import { FORM_TIME_OUT_SEC } from './config.js';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

if (module.hot) {
  module.hot.accept();
}

const controlRecipe = async function () {
  try {
    const id = window.location.hash.slice(1);
    if (!id) return;
    //Render loading screen
    recipeView.renderSpinner();

    //Updating results for active class
    resultsView.update(model.getSearchResultsPage());
    //Loading recipe from web api
    await model.loadRecipe(id);
    //rendering recipe
    recipeView.render(model.state.recipe);
    //Render bookmarks list when loading page
    model.state.bookmarks.length !== 0
      ? bookmarksView.render(model.state.bookmarks)
      : bookmarksView.renderMessage();
    //Render shopping list when loading page
    model.state.shoppingList.length === 0
      ? shoppingListView.renderMessage()
      : shoppingListView.render(model.state.shoppingList);
  } catch (err) {
    recipeView.renderError();
    console.log(err);
  }
};

const controlSearhResults = async function () {
  try {
    // Getting query from search field
    const query = searchView.getQuery();
    //Render loading screen
    resultsView.renderSpinner();
    // Loading search data from web API
    await model.loadSearcResults(query);
    //Rendering results
    resultsView.render(model.getSearchResultsPage());
    //Render Show Sort Results
    sortResultsView.showSortResults();
    //Render pagination
    paginationView.render(model.state.search);
  } catch (err) {
    console.log(err);
  }
};

const controlPagination = function (goTo) {
  //Render serach results
  resultsView.render(model.getSearchResultsPage(goTo));
  //Rendser pagination
  paginationView.render(model.state.search);
};

const controlServings = function (updateTo) {
  //Update servingd
  model.updateServings(updateTo);
  //Update recipe with new servings
  recipeView.update(model.state.recipe);
};

const controlAddBookmark = function () {
  //Bookmarks add to / remove from model state
  model.addRemoveBookmark(model.state.recipe);
  //Bookmark mark added to recipe view
  recipeView.update(model.state.recipe);
  //Bookmarks list rendered
  model.state.bookmarks.length !== 0
    ? bookmarksView.render(model.state.bookmarks)
    : bookmarksView.renderMessage();
};

const constrolAddRecipe = async function (newRecipe) {
  try {
    //render loading
    addRecipeView.renderSpinner();
    //Upload new recipe to WEB API and store the recipe to model.state.recipe
    await model.addNewRecipe(newRecipe);
    //Render recipe wiev with new recipe
    recipeView.render(model.state.recipe);
    //Render Bookmarks
    bookmarksView.render(model.state.bookmarks);
    //Show success message;
    addRecipeView.renderMessage();
    //Close add new recipe window
    setTimeout(() => {
      addRecipeView.toggleWindow();
    }, FORM_TIME_OUT_SEC * 1000);
  } catch (err) {
    console.log(err);
  }
};

const controlAddShoppingList = function () {
  //Item add to/remove from model shopping list
  model.addRemoveShoppngList(model.state.recipe);
  //Shopping List added item changed on recipeview
  recipeView.update(model.state.recipe);
  //Shopping list rendered
  model.state.shoppingList.length === 0
    ? shoppingListView.renderMessage()
    : shoppingListView.render(model.state.shoppingList);
};

const controlRemoveShoppingList = function (btn) {
  //Get recipe id on shopping list
  const id = shoppingListView.getrecipeId(btn);
  //Find recipe from shopping list
  const recipe = model.findRecipeShoppingList(id);
  //remove recipe from shopping list
  model.addRemoveShoppngList(recipe);
  //Render shopping list view
  model.state.shoppingList.length === 0
    ? shoppingListView.renderMessage()
    : shoppingListView.render(model.state.shoppingList);
  //Update recipe view
  recipeView.update(model.state.recipe);
};

const controlSortResults = function (sortBy) {
  //Sorting searc results
  model.sortResults(sortBy);
  //Render sorted results
  resultsView.render(model.getSearchResultsPage());
  //Render pagination
  paginationView.render(model.state.search);
};

const renderBookMarksAndShoppingList = function () {
  model.state.bookmarks.length !== 0
    ? bookmarksView.render(model.state.bookmarks)
    : bookmarksView.renderMessage();
  //Render shopping list when loading page
  model.state.shoppingList.length === 0
    ? shoppingListView.renderMessage()
    : shoppingListView.render(model.state.shoppingList);
};

const init = function () {
  renderBookMarksAndShoppingList();
  searchView.addHandlerSearchResults(controlSearhResults);
  recipeView.addHandlerRender(controlRecipe);
  paginationView.addHandlerPagination(controlPagination);
  recipeView.addHandlerServings(controlServings);
  recipeView.addHandlerAddBookmark(controlAddBookmark);
  recipeView.addHandlerAddShoppingList(controlAddShoppingList);
  addRecipeView.addHandlerUpload(constrolAddRecipe);
  shoppingListView.addhandlerRemoveRecipe(controlRemoveShoppingList);
  sortResultsView.addHandlerSortResults(controlSortResults);
};
init();
